$(document).ready(function () {

    $('.animate-strip h1').each(function () {
        $(this).css('opacity', '1');
    });

    $('.animate-strip h1').each(function () {
        var $t = $(this),
            rows = $.trim($t.html()).split('<br>');

        $t.html('');

        $.each(rows, function (i, val) {
            $('<span class="effect-row"></span>').appendTo($t);

            var letters = $.trim(val).split('');

            $.each(letters, function (j, v) {
                v = (v == ' ') ? '&nbsp;' : v;
                $('<span>' + $.trim(v) + '</span>').appendTo($('.effect-row:last', $t));
            });

        });
    });


    $(document).ready(function () {
        for (i = 0; i < $('.animate-strip span').length; i++) {
            (function (ind) {
                setTimeout(function () {
                    $('.animate-strip span:not(".effect-row")').eq(ind).toggleClass('animate');
                }, ind * 15);
            })(i);
        }
    });



    // $('body').click(function () {
    //     for (i = 0; i < $('.animate-strip span').length; i++) {
    //         (function (ind) {
    //             setTimeout(function () {
    //                 $('.animate-strip span:not(".effect-row")').eq(ind).toggleClass('animate');
    //             }, ind * 15);
    //         })(i);
    //     }
    // }).click();

});